"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("../type/entity");
function getEvaluateInteractionParam(command, user, reviewerId, submissionId) {
    const { timeStamp: reviewedOn, contentId, actorType = entity_1.ActorType.USER } = command;
    const { userId, companyId } = user;
    const evaluateInteractionParam = {
        companyId,
        evaluatedSubmissionId: submissionId,
        evaluation: entity_1.CheckpointSubmissionStatus.PENDING,
        feedbackText: '',
        reviewedOfId: userId,
        reviewerId,
        reviews: [],
        rootContentId: contentId,
        timeStamp: reviewedOn,
        actorType
    };
    return evaluateInteractionParam;
}
exports.getEvaluateInteractionParam = getEvaluateInteractionParam;
//# sourceMappingURL=getEvaluateInteractionParam.js.map